/**
 * AppealSlice Core Reducers
 * 
 * Core CRUD operations for the appeal entity.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { AppealLetterView } from '../../types/appealTypes';
import { AppealSliceState, initialState } from '../state';

// =============================================================================
// CORE REDUCERS
// =============================================================================

/**
 * Set the current appeal
 */
export const setCurrentAppeal: CaseReducer<AppealSliceState, PayloadAction<AppealLetterView | null>> = (
  state,
  action
) => {
  state.currentAppeal = action.payload;
  state.hasUnsavedChanges = false;
  state.selectedPolicyReferences = action.payload?.policyReferences || [];
};

/**
 * Clear/reset the current appeal to initial state
 */
export const clearAppeal: CaseReducer<AppealSliceState> = (state) => {
  state.currentAppeal = null;
  state.hasUnsavedChanges = false;
  state.selectedPolicyReferences = [];
  state.isEditing = false;
  state.generationInProgress = false;
  state.error = null;
};

/**
 * Reset the entire appeal state to initial values
 */
export const resetAppealState: CaseReducer<AppealSliceState> = () => initialState;
